<xi-generic-modal
  [canBackdropClose]="false"
  [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
  [isVisible]="true"
  (onClose)="close()"
  maxWidth="700px"
>
  <div slot="children">
    <xi-basic-tile [hasTopBar]="false" [stretch]="true" [isInteractive]="false">
      <div slot="children">
        <div class="xi-modal__container tx-editor__container" *transloco="let t; read: 'tx-editor'">
          <h2 class="xi-modal__title">{{ t('advanced-column-config') }}</h2>

          <div class="xi-modal__content">
            <label for="tx-editor-data-input" class="kxi-text-large">{{
              t('data-transformation')
            }}</label>
            <div class="tx-editor__text-area">
              <xi-text-area
                id="tx-editor-data-input"
                [placeholder]="t('enter-here')"
                appAutoFocus="xiTextArea"
                [(ngModel)]="transform"
                [height]="100"
                [resize]="true"
              ></xi-text-area>
            </div>

            <h3>{{ t('additional-options') }}</h3>
            <div class="tx-editor__checkbox">
              <xi-checkbox
                color="CX"
                [label]="t('group-by-column')"
                [(ngModel)]="groupbyCheckbox"
              ></xi-checkbox>
            </div>
          </div>
          <div class="xi-modal__actions tx-editor__actions">
            <xi-default-button
              [text]="t('close')"
              fill="text"
              (onClick)="close()"
            ></xi-default-button>

            <xi-default-button [text]="t('save')" (onClick)="confirm()"></xi-default-button>
          </div>
        </div></div
    ></xi-basic-tile></div
></xi-generic-modal>
